import React, { useEffect, useRef, useState } from 'react'
import axios from '../../API/axios';
import { Button } from 'react-bootstrap';
import AttachEmailSharpIcon from '@mui/icons-material/AttachEmailSharp';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import { Link, useParams } from 'react-router-dom';
import Checkbtn from './Checkbtn';
import html2canvas from 'html2canvas';
import toast from 'react-hot-toast';
import ResumePdf from '../Resume/ResumePdf';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';

import jsPDF from 'jspdf';


const CandidateProfile = () => {
  const sessionId = localStorage.getItem("sessionId");
  const UserType = localStorage.getItem("userType");
  const { CandidateId } = useParams();

  //  *******************************     RESUME LISTING   ************************************************

  const [userEducation, setUserEducation] = useState([]);
  const [userAwards, setUserAwards] = useState([]);
  const [userExperience, setUserExperience] = useState([]);
  const [userCertification, setUserCertification] = useState([]);
  const [userDataInfo, setUserDataInfo] = useState([]);
  console.log(userDataInfo, "userDataInfo");

  const [projectData, setProjectData] = useState([]);
  const [userSkill, setUserSkill] = useState([]);

  const getUserCv = async () => {
    const data = {
      sessionId: sessionId,
      userType: UserType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
    };
    try {
      await axios
        .post(`/Resume/Get`, data).then((resData) => {
          console.log("User resume", resData.data.responseData);
          setUserDataInfo(resData.data.responseData.userDataInfo);
          setUserEducation(resData.data.responseData.educations);
          setUserAwards(resData.data.responseData.awards);
          setUserExperience(resData.data.responseData.experiences);
          setUserSkill(resData.data.responseData.skills);
          setUserCertification(resData.data.responseData.certifications);
          setProjectData(resData.data.responseData.projects);
        });
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };
  useEffect(() => {
    getUserCv();
  }, []);


  //  *******************************    RESUME LISTING  ************************************************

  //  *******************************    PDF Download  ************************************************

  const pdfRef = useRef();

  const downloadResume = async () => {
    try {
      if (!pdfRef.current) {
        throw new Error("PDF content is not available. Reference is null.");
      }
      pdfRef.current.style.visibility = "visible";
      pdfRef.current.style.position = "absolute";
      pdfRef.current.style.zIndex = "-1";

      const canvas = await html2canvas(pdfRef.current, {
        scale: 1.5,
        useCORS: true,
      });

      pdfRef.current.style.visibility = "hidden";
      pdfRef.current.style.position = "static";

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("portrait", "pt", "a4");
      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, width, height);
      pdf.save("resume.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error.message);
    }
  };

  // useEffect(() => {
  //   if (profileData) {
  //     console.log("Profile data loaded:", profileData);
  //   }
  // }, [profileData]);



  //  *******************************    PDF Download  ************************************************



  return (
    <>
      <div className="profile-resume-main-container pt-3">
        <div className="profile-resume-heading-cont d-flex align-items-center p-4">
          <div className="profile-resume-empty-cont me-2"></div>
          <h2>Profile</h2>
        </div>

        <div className="profile-resume-userinfo mb-3">
          <div className="row p-4">
            <div className="col-md-2">
              <div className="profile-resume-image">
                <img src={userDataInfo.userImage} alt="" srcset="" />
              </div>
            </div>
            <div className="col-md-8">
              <div className="profile-resume-designation f-14 f-600">
                {userDataInfo.headLine}
              </div>
              <div className="d-flex align-items-center mb-3 Main-resume-username">
                <div className="profile-resume-username me-2">
                  {userDataInfo.fullName}
                </div>
              </div>
              <div className="d-flex Resume-Skills-Country-Mobile">
                <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                  Blender
                </div>
                <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                  Sketch
                </div>
                <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                  Adobe XD
                </div>
                <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                  Figma
                </div>
                <div className="profile-resume-country d-flex align-items-center">
                  <div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
                    <span class="icon-map-pin me-2"></span>
                    {userDataInfo.currentCity}
                  </div>

                </div>
              </div>
            </div>
            <div className="col-md-2">

              <Checkbtn />
              <div className="edit-profile-btn text-center">
                <Button className="f-13 mt-2  ">
                  <Link to={`/ManageResume/Candidate`}
                  >
                    Manage
                  </Link>
                </Button>
              </div>

              <div className="edit-profile-btn text-center">
                <Button className="f-13   mt-2" onClick={downloadResume}>
                  Download
                </Button>
              </div>

              {/* <div style={{ display: "none" }}> */}
              <div style={{ visibility: "hidden", position: "absolute", zIndex: -1 }}>
                <ResumePdf ref={pdfRef} resumeData={userDataInfo} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">

            <div className=" mt-4 mb-2">
              <h6 className="profile-resume-about-heading f-24 f-800 mb-3">Contact</h6>
            </div>
            {userDataInfo?.email === null ? (
              ""
            ) : (
              <div className="content persnol-info mt-2">
                <div className="d-flex">
                  <AttachEmailSharpIcon className="me-2" /> <p>{userDataInfo.email}</p>
                </div>
              </div>
            )}
            {userDataInfo?.dob === null ? (
              ""
            ) : (
              <div className="content mb-2">
                <div className="d-flex">
                  <CalendarMonthSharpIcon className="me-2" /> <p>{userDataInfo.dob}</p>
                </div>
              </div>
            )}
            {userDataInfo?.webSiteLink === null ? (
              ""
            ) : (
              <div className="content mb-2">
                <div className="d-flex">
                  <LinkSharpIcon className="me-2" /> <p>{userDataInfo.webSiteLink}</p>
                </div>
              </div>
            )}
            {userDataInfo?.languages?.length > 0 ? (
                      <div className="content">
                        <div className="d-flex">
                          <LanguageSharpIcon className="me-2" />
                          {userDataInfo.languages.map((language, index) => (
                            <p key={index} className="me-2">
                              {language}
                            </p>
                          ))}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
            {userAwards.length === 0 ? (
              ""
            ) : (
              <>
                <div className="profile-resume-education mt-2">
                  <div className="profile-resume-about-heading f-24 f-800 mb-3">
                    Awards
                  </div>
                  {userAwards && userAwards
                    .filter((item) => !item.isDeleted)
                    .map((item) => (
                      <div className="d-flex">
                        <div className="profile-resume-verticle-line me-4"></div>
                        <div>
                          <div className="profile-resume-education-details mb-3">
                            <div className="profile-resume-university f-14 f-700">
                              {item.name}  <span className='ms-1 f-13 f-400'>{item.issueDate}  </span>
                            </div>
                            <div className="profile-resume-education-designation-info f-13 f-400">
                              <span className='ms-1 f-13 f-400'> ({item.cityName})</span> {item.description}
                            </div>
                          </div>

                        </div>
                      </div>
                    ))}

                </div>
              </>
            )}
            {userSkill.length === 0 ? (
              ""
            ) : (
              <>
                <div className="profile-resume-education mt-2">
                  <div className="profile-resume-about-heading f-24 f-800 mb-3">
                    Skills
                  </div>
                  {userSkill && userSkill
                    .filter((item) => !item.isDeleted)
                    .map((item) => (
                      <div className="d-flex">
                        <div className="profile-resume-verticle-line me-4"></div>
                        <div>
                          <div className="profile-resume-education-details mb-3">
                            <div className="profile-resume-university f-14 f-400">
                              {item.skillName}
                            </div>

                          </div>

                        </div>
                      </div>
                    ))}

                </div>
              </>
            )}
            {userCertification.length === 0 ? (
              ""
            ) : (
              <>
                <div className="profile-resume-education mt-2">
                  <div className="profile-resume-about-heading f-24 f-800 mb-3">
                    Certificates
                  </div>
                  {userCertification && userCertification
                    .filter((item) => !item.isDeleted)
                    .map((item) => (
                      <div className="d-flex">
                        <div className="profile-resume-verticle-line me-4"></div>
                        <div>
                          <div className="profile-resume-education-details mb-3">
                            <div className="profile-resume-university f-14 f-700">
                              {item.name}  <span className='ms-1 f-13 f-400'>{item.issueDate}  </span>
                            </div>
                            <div className="profile-resume-education-designation-info f-13 f-400">
                              <span className='ms-1 f-13 f-400'> ({item.cityName})</span> {item.description}
                            </div>
                          </div>

                        </div>
                      </div>
                    ))}

                </div>
              </>
            )}

          </div>

          <div className="col-md-8">
            <div className="profile-resume-parent-cont p-4 rounded-4">
              <div className="profile-resume-about">
                <div className="profile-resume-about-heading f-24 f-800 mb-3">
                  About me
                </div>

                <div className="profile-resume-about-info">
                  <p className="f-16 f-400">
                    {userDataInfo.about}
                  </p>

                </div>
              </div>
              {userEducation.length === 0 ? (
                ""
              ) : (
                <>
                  <div className="profile-resume-education">
                    <div className="profile-resume-about-heading f-24 f-800 mb-3">
                      Education
                    </div>
                    {userEducation && userEducation
                      .filter((item) => !item.isDeleted)
                      .map((item) => (
                        <div className="d-flex">
                          <div className="profile-resume-verticle-line me-4"></div>
                          <div>
                            <div className="profile-resume-education-details mb-3">
                              <div className="profile-resume-university f-14 f-700">
                                {item.institutionName} <span className='ms-2'>{item.startYear} - {item.endYear}</span>
                              </div>
                              <div className="profile-resume-education-designation f-16 f-700">
                                {/* {item.institutionName} */}
                              </div>
                              <div className="profile-resume-education-designation-info f-14 f-400">
                                {item.description}
                              </div>
                            </div>

                          </div>
                        </div>
                      ))}

                  </div>
                </>
              )}
              {userExperience.length === 0 ? (
                ""
              ) : (
                <>
                  <div className="profile-resume-education mt-2">
                    <div className="profile-resume-about-heading f-24 f-800 mb-3">
                      Experience
                    </div>
                    {userExperience && userExperience
                      .filter((item) => !item.isDeleted)
                      .map((item) => (
                        <div className="d-flex">
                          <div className="profile-resume-verticle-line me-4"></div>
                          <div>
                            <div className="profile-resume-education-details mb-3">
                              <div className="profile-resume-university f-14 f-700">
                                {item.companyName} <span className='ms-2 f-13 f-400'> ({item.cityName})</span>
                              </div>
                              <div className="profile-resume-education-designation f-16 f-700">
                                <span className='me-2 f-14 f-700'>{item.startDate} / {item.endDate} </span>
                              </div>
                              <div className="profile-resume-education-designation-info f-13 f-400">
                                <span className='me-2 f-14 f-700'>{item.jobTitle}</span> {item.description}
                              </div>
                            </div>

                          </div>
                        </div>
                      ))}

                  </div>
                </>
              )}
              {projectData.length === 0 ? (
                ""
              ) : (
                <>
                  <div className="profile-resume-education mt-2">
                    <div className="profile-resume-about-heading f-24 f-800 mb-3">
                      Projects
                    </div>
                    {projectData && projectData
                      .filter((item) => !item.isDeleted)
                      .map((item) => (
                        <div className="d-flex">
                          <div className="profile-resume-verticle-line me-4"></div>
                          <div>
                            <div className="profile-resume-education-details mb-3">
                              <div className="profile-resume-university f-14 f-700">
                                {item.name}  <span className='ms-1 f-13 f-400'>{item.startMonth}-{item.startYear} /{item.endMonth}-{item.endYear}  </span>
                              </div>
                              <div className="profile-resume-education-designation-info f-13 f-400">
                                {item.description}
                              </div>
                            </div>

                          </div>
                        </div>
                      ))}

                  </div>
                </>
              )}


            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateProfile;
